import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { RequestAccessActions } from '../actions/index';
@Injectable()
export class RequestAccessEffects {
  
  constructor(
    private actions: Actions,
    private apiService: ApiService,
    private globalService: GlobalService,
  ) { }

  FetchCountries$ = createEffect(() =>
    this.actions.pipe(
      ofType(RequestAccessActions.loadCountries),
      switchMap(() => this.apiService.getCountries()),
      map((data) => {
        return RequestAccessActions.loadCountriesSuccess({ countries: data?.countries });
      }),
      catchError((error) =>
        of(RequestAccessActions.loadCountriesFail({ payload: error }))
      )
    )
  );

  submitRequestAccess$ = createEffect(() =>
    this.actions.pipe(
      ofType(RequestAccessActions.submitForm),
      switchMap((action) => {
        this.globalService.loadingSubject.next(true)
        return this.apiService.submitRequestAccess(action.formData).pipe(
          map(() => {
              this.globalService.loadingSubject.next(false)
            return RequestAccessActions.submitFormSuccess({ status: true });
          }),
          catchError((error) => {
            return of(RequestAccessActions.submitFormFail({ payload: error }));
          })
        );
      })
    )
  );

}
